/* not wrong. — theme behaviour */
(function () {
  'use strict';
  document.documentElement.classList.add('nw-js');

  var NS = 'http://www.w3.org/2000/svg';
  var PATHS = {
    core: 'M66 14 C76 26 124 26 134 14 L176 30 L198 80 L166 94 L158 82 L160 204 L40 204 L42 82 L34 94 L2 80 L24 30 Z',
    baby: 'M72 18 C82 30 118 30 128 18 L160 32 L178 66 L154 76 L148 66 C142 110 148 150 154 200 L46 200 C52 150 58 110 52 66 L46 76 L22 66 L40 32 Z'
  };
  var FILLS = {
    black: ['#18181a', '#f3f2ee', 'none'],
    white: ['#fdfdfb', '#16161a', '#cfcec8'],
    natural: ['#e9dfcb', '#16161a', 'none'],
    grey: ['#bdbdb9', '#16161a', 'none']
  };

  function wrap(s, max) {
    var words = String(s || '').split(/\s+/), lines = [], cur = '';
    words.forEach(function (w) {
      if (!w) return;
      if ((cur + ' ' + w).trim().length > max && cur) { lines.push(cur); cur = w; }
      else { cur = (cur + ' ' + w).trim(); }
    });
    if (cur) lines.push(cur);
    return lines.slice(0, 4);
  }

  function drawTee(svg) {
    var kind = (svg.getAttribute('data-nw-tee') || 'core').toLowerCase().indexOf('baby') > -1 ? 'baby' : 'core';
    var colour = (svg.getAttribute('data-colour') || 'black').toLowerCase();
    var c = FILLS[colour] || FILLS.black;
    var slogan = svg.getAttribute('data-slogan') || '';
    while (svg.firstChild) svg.removeChild(svg.firstChild);
    svg.setAttribute('viewBox', '0 0 200 210');
    var path = document.createElementNS(NS, 'path');
    path.setAttribute('d', PATHS[kind]);
    path.setAttribute('fill', c[0]);
    path.setAttribute('stroke', c[2]);
    path.setAttribute('stroke-width', '1.5');
    svg.appendChild(path);
    var baby = kind === 'baby';
    var lines = wrap(slogan, baby ? 11 : 13);
    var longest = lines.reduce(function (m, l) { return Math.max(m, l.length); }, 0);
    var fs = baby ? 11 : 12.5;
    if (longest > (baby ? 11 : 13)) fs = fs * (baby ? 11 : 13) / longest;
    var x = baby ? 64 : 58, y0 = baby ? 64 : 66;
    var t = document.createElementNS(NS, 'text');
    t.setAttribute('fill', c[1]);
    t.setAttribute('style', 'font-family:Archivo,Arial,sans-serif;font-weight:700;font-size:' + fs + 'px;letter-spacing:-.02em');
    lines.forEach(function (l, i) {
      var ts = document.createElementNS(NS, 'tspan');
      ts.setAttribute('x', x);
      ts.setAttribute('y', y0 + i * fs * 1.08);
      ts.textContent = l;
      t.appendChild(ts);
    });
    svg.appendChild(t);
  }
  function drawAll(root) { (root || document).querySelectorAll('svg[data-nw-tee]').forEach(drawTee); }
  window.nwDrawTee = drawTee;

  /* ---------- header ---------- */
  function initHeader() {
    var header = document.querySelector('[data-nw-header]');
    if (!header) return;
    var burger = header.querySelector('[data-nw-burger]');
    if (burger) burger.addEventListener('click', function () {
      var open = header.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('click', function (e) {
      header.querySelectorAll('details[open]').forEach(function (d) { if (!d.contains(e.target)) d.removeAttribute('open'); });
    });
  }

  /* ---------- cart helpers ---------- */
  function money(cents) { var v = cents / 100; return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2)); }
  function tierMessage(count) {
    if (count < 2) return { h: 'Add 1 more for free shipping', p: '2 tees for $89, and shipping’s on us.' };
    if (count === 2) return { h: '2 for $89 unlocked. Free shipping too.', p: 'Add 1 more: 3 tees for $119.' };
    if (count < 5) return { h: (count === 3 ? '3 for $119 unlocked.' : '3-tee price applied.'), p: 'Add ' + (5 - count) + ' more: 5 tees for $179, best value.' };
    if (count < 10) return { h: '5 for $179 unlocked. Best value.', p: 'Getting 10+ for a group? They’re $25 each.' };
    return { h: 'Group price unlocked.', p: '10+ tees at about $25 each. Not wrong.' };
  }
  function updateCounts(count) {
    document.querySelectorAll('[data-nw-cart-count]').forEach(function (el) { el.textContent = count; el.setAttribute('data-count', count); });
  }
  var toastTimer;
  function toast(title, count) {
    var el = document.querySelector('[data-nw-toast]');
    if (!el) return;
    var m = tierMessage(count);
    el.querySelector('[data-nw-toast-h]').textContent = title;
    el.querySelector('[data-nw-toast-p]').textContent = m.h + ' ' + m.p;
    el.querySelector('[data-nw-toast-bar]').style.width = Math.min(count / 5, 1) * 100 + '%';
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 6500);
  }
  function initToast() {
    var el = document.querySelector('[data-nw-toast]');
    if (!el) return;
    el.querySelector('[data-nw-toast-close]').addEventListener('click', function () { el.classList.remove('is-on'); });
  }

  /* ---------- product ---------- */
  function initProduct() {
    var root = document.querySelector('[data-nw-product]');
    if (!root) return;
    var dataEl = root.querySelector('[data-nw-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = root.querySelector('[data-nw-form]');
    var idInput = form.querySelector('input[name="id"]');
    var btn = form.querySelector('[data-nw-add]');
    var priceEl = root.querySelector('[data-nw-price]');
    var stage = root.querySelector('[data-nw-stage] svg');
    var optNames = product.options.map(function (o) { return typeof o === 'string' ? o : o.name; });

    function current() {
      return optNames.map(function (name) {
        var checked = root.querySelector('input[data-nw-opt="' + name + '"]:checked');
        return checked ? checked.value : null;
      });
    }
    function findVariant(values) {
      return product.variants.find(function (v) {
        return values.every(function (val, i) { return v.options[i] === val; });
      });
    }
    function exists(partial) {
      return product.variants.some(function (v) {
        return partial.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }
    function sync(fromUser) {
      var vals = current();
      // disable option values that don't exist with the earlier selections
      optNames.forEach(function (name, idx) {
        if (idx === 0) return;
        var inputs = root.querySelectorAll('input[data-nw-opt="' + name + '"]');
        var firstOk = null;
        inputs.forEach(function (inp) {
          var test = vals.slice(0, idx).concat([inp.value]);
          var ok = exists(test);
          inp.disabled = !ok;
          if (ok && !firstOk) firstOk = inp;
        });
        var chosen = root.querySelector('input[data-nw-opt="' + name + '"]:checked');
        if ((!chosen || chosen.disabled) && firstOk) { firstOk.checked = true; }
        vals = current();
      });
      optNames.forEach(function (name) {
        var out = root.querySelector('[data-nw-selected="' + name + '"]');
        var c = root.querySelector('input[data-nw-opt="' + name + '"]:checked');
        if (out && c) out.textContent = c.value;
      });
      var v = findVariant(vals);
      if (v) {
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price);
        btn.disabled = !v.available;
        btn.querySelector('[data-nw-add-label]').textContent = v.available ? 'Add to cart · ' + money(v.price) : 'Unavailable';
        if (fromUser && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString());
        }
      } else {
        btn.disabled = true;
        btn.querySelector('[data-nw-add-label]').textContent = 'Unavailable';
      }
      var fitIdx = optNames.indexOf('Fit'), colIdx = optNames.indexOf('Colour');
      if (stage && root.getAttribute('data-nw-photos') !== 'true') {
        stage.setAttribute('data-nw-tee', fitIdx > -1 && vals[fitIdx] ? vals[fitIdx] : 'core');
        stage.setAttribute('data-colour', colIdx > -1 && vals[colIdx] ? vals[colIdx] : 'black');
        drawTee(stage);
      }
      root.querySelectorAll('[data-nw-thumb]').forEach(function (b) {
        var on = b.getAttribute('data-fit') === vals[fitIdx] && b.getAttribute('data-colour') === vals[colIdx];
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    root.addEventListener('change', function (e) { if (e.target.matches('input[data-nw-opt]')) sync(true); });
    root.querySelectorAll('[data-nw-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        var f = root.querySelector('input[data-nw-opt="Fit"][value="' + b.getAttribute('data-fit') + '"]');
        var c = root.querySelector('input[data-nw-opt="Colour"][value="' + b.getAttribute('data-colour') + '"]');
        if (f) f.checked = true;
        sync(false);
        if (c && !c.disabled) c.checked = true;
        sync(true);
      });
    });
    root.querySelectorAll('[data-nw-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = form.querySelector('input[name="quantity"]');
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.getAttribute('data-nw-qty'), 10));
      });
    });
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      btn.disabled = true;
      var qty = parseInt(form.querySelector('input[name="quantity"]').value, 10) || 1;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: qty }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart.js'); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCounts(cart.item_count);
          toast('In the cart. ' + product.title, cart.item_count);
          btn.disabled = false;
        })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
    // mobile sticky add-to-cart
    var sticky = root.querySelector('[data-nw-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      document.body.classList.add('nw-has-sticky-ready');
      var io = new IntersectionObserver(function (entries) {
        var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', off);
        sticky.setAttribute('aria-hidden', off ? 'false' : 'true');
        document.body.classList.toggle('nw-has-sticky', off);
      });
      io.observe(btn);
      sticky.querySelector('[data-nw-sticky-add]').addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
      root.addEventListener('change', function () {
        var vals = current();
        var sub = sticky.querySelector('[data-nw-sticky-sub]');
        if (sub) sub.textContent = vals.filter(Boolean).join(' · ');
        var pr = sticky.querySelector('[data-nw-sticky-price]');
        if (pr && priceEl) pr.textContent = priceEl.textContent;
      });
    }
    sync(false);
  }

  /* ---------- cart page ---------- */
  function initCart() {
    var form = document.querySelector('[data-nw-cart-form]');
    if (!form) return;
    form.querySelectorAll('[data-nw-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = form.querySelector('#' + b.getAttribute('data-target'));
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-nw-step'), 10));
        form.submit();
      });
    });
    form.querySelectorAll('input[name="updates[]"]').forEach(function (i) { i.addEventListener('change', function () { form.submit(); }); });
  }

  /* ---------- suggest a slogan quiz ---------- */
  function initSuggest() {
    var drawer = document.querySelector('[data-nw-sg]');
    function open() {
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var f = drawer.querySelector('input,textarea,button');
      setTimeout(function () { if (f) f.focus(); }, 350);
    }
    function close() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    document.querySelectorAll('[data-nw-suggest-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { if (drawer) { e.preventDefault(); open(); } });
    });
    if (drawer) {
      drawer.querySelectorAll('[data-nw-sg-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      var h = window.location.hash;
      if (h === '#suggest' || h.indexOf('#nw-suggest-form-drawer') === 0 || (window.location.search.indexOf('contact_posted') > -1 && drawer.querySelector('.nw-sg__done, .nw-alert'))) open();
    }

    document.querySelectorAll('[data-nw-quiz]').forEach(function (quiz) {
      var steps = quiz.querySelectorAll('[data-nw-quiz-step]');
      var bars = quiz.querySelectorAll('[data-nw-quiz-bar]');
      var back = quiz.querySelector('[data-nw-quiz-back]');
      var next = quiz.querySelector('[data-nw-quiz-next]');
      var submit = quiz.querySelector('[data-nw-quiz-submit]');
      var input = quiz.querySelector('[data-nw-quiz-slogan]');
      var counter = quiz.querySelector('[data-nw-quiz-count]');
      var preview = quiz.querySelector('[data-nw-quiz-preview]');
      var at = 0;
      if (!steps.length) return;
      function show(i) {
        at = i;
        steps.forEach(function (s, n) { s.hidden = n !== i; });
        bars.forEach(function (b, n) { b.classList.toggle('is-on', n <= i); });
        back.hidden = i === 0;
        next.hidden = i === steps.length - 1;
        submit.hidden = i !== steps.length - 1;
      }
      function valid(i) {
        var ok = true;
        steps[i].querySelectorAll('input,textarea').forEach(function (el) { if (!el.checkValidity()) { ok = false; } });
        if (!ok) { var bad = steps[i].querySelector(':invalid'); if (bad) bad.reportValidity(); }
        return ok;
      }
      next.addEventListener('click', function () { if (valid(at)) show(Math.min(at + 1, steps.length - 1)); });
      back.addEventListener('click', function () { show(Math.max(at - 1, 0)); });
      if (input && preview) {
        var draw = function () {
          preview.setAttribute('data-slogan', input.value.trim() || 'Your line goes here');
          drawTee(preview);
          if (counter) counter.textContent = input.value.length + ' / ' + input.maxLength;
        };
        input.addEventListener('input', draw);
        quiz.querySelectorAll('[data-nw-quiz-colour]').forEach(function (b) {
          b.addEventListener('click', function () {
            quiz.querySelectorAll('[data-nw-quiz-colour]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
            b.setAttribute('aria-pressed', 'true');
            preview.setAttribute('data-colour', b.getAttribute('data-nw-quiz-colour'));
            draw();
          });
        });
        draw();
      }
      show(0);
    });
  }

  function init() { drawAll(); initHeader(); initToast(); initProduct(); initCart(); initSuggest(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { drawAll(); });
})();
